import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M18.36 6.64A9 9 0 0 1 20.77 15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 2 20 20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PowerOff";
const PowerOff = memo(themed(Icon));
export {
  PowerOff
};
//# sourceMappingURL=power-off.js.map
